export const highGasDelays = {
  title: 'Will Palm bridge always take longer during periods of high gas?',
  content: `
    The current system is structured to help protect newcomers unfamiliar with
    these concepts. In the future, Palm will allow users flexibility in choosing 
    between gas costs vs processing speeds. This will help prevent people from wasting
    gas, or their transactions from getting stuck.
  `,
};

export const transferTimes = {
  title: 'How long does it take for my ETH, tokens, or NFTs to move across the Palm bridge?',
  content: `
    The time for the bridge process depends on congestion and gas fees on the Ethereum network.
    <br><br>
    The bridging process may take anywhere from a few minutes to several hours. If you are
    transferring from Palm to Ethereum, you may incur significant delays in transferring
    your asset when gas fees are high. We currently display a warning on the bridge when
    this is the case. Waiting for lower gas fees may mitigate delays.
    <br><br>
    If gas fees are not high and your transaction is taking longer than expected, contact
    ConsenSys support here. We will check on the progress for you.
  `,
};
